<template>
  <div class="login">
    <h1 class="top">Bodor+3.0 {{ $t("login.new") }}</h1>
    <div class="loginbg">
      <div class="loginleft">
        <p class="title">{{ $t("login.choose") }}Bodor+?</p>
        <ul class="about-list">
          <li>
            <span class="fa fa-dot-circle-o"></span>
            <span>{{ $t("login.info1") }}</span>
          </li>
          <li>
            <span class="fa fa-dot-circle-o"></span>
            <span>{{ $t("login.info2") }}</span>
          </li>
          <li>
            <span class="fa fa-dot-circle-o"></span>
            <span>{{ $t("login.info3") }}</span>
          </li>
        </ul>
        <p class="leftbottom">
          {{ $t("login.noaccount") }}?
          <span class="register" @click="register">{{ $t("login.register") }}</span>
          <span class="back" @click="back">{{ $t("login.back") }}</span>
        </p>
      </div>
      <div class="loginbox">
        <h3>{{ $t("login.login") }}Bodor+3.0</h3>
        <form class="inputbox">
          <input
            type="text"
            class="login_input"
            name="name"
            v-model="account"
            autocomplete="on"
            :placeholder="$t('login.enteraccount')"
            @click="noError"
          />
          <input
            v-model="password"
            class="login_input"
            type="password"
            name="password"
            @keyup.enter="login"
            autocomplete="on"
            :placeholder="$t('login.enterpassword')"
            @click="noError"
          />
        </form>
        <a-button
          type="primary"
          class="loginbtn"
          @click="login"
          :loading="loginLoading"
          >{{ $t("login.login") }}</a-button
        >
        <p class="forget" @click="forget">{{ $t("login.forget") }}</p>
      </div>
    </div>

    <a-modal v-model:open="open" :title="$t('login.resert')" centered @ok="handleOk">
      <a-form
        style="margin-top: 30px"
        :model="formState"
        name="basic"
        :label-col="{ span: 8 }"
        :wrapper-col="{ span: 16 }"
        autocomplete="off"
      >
        <a-form-item
          :label="$t('login.account')"
          name="email"
          :rules="[{ required: true, message: t(`register.enteraccount`) }]"
        >
          <a-input
            v-model:value="formState.email"
            :placeholder="$t('register.enteraccount')"
          />
        </a-form-item>

        <a-form-item
          :label="$t('login.code')"
          name="code"
          :rules="[{ required: true, message: t(`register.codein`) }]"
        >
          <a-row justify="space-between">
            <a-col :span="14"
              ><a-input
                v-model:value="formState.code"
                :placeholder="$t('register.codein')"
            /></a-col>
            <a-col :span="10">
              <a-button
                :ref="codeinfo"
                style="float: right"
                :loading="codeLoading"
                @click="getCode"
                :disabled="codeDisabled"
                >{{ codeinfo }}</a-button
              ></a-col
            >
          </a-row>
        </a-form-item>

        <a-form-item
          :label="$t('login.nPassword')"
          name="password"
          :rules="[{ required: true, message: t(`login.nPasswordin`) }]"
        >
          <a-input-password
            v-model:value="formState.password"
            autocomplete="off"
            :placeholder="$t('login.nPasswordin')"
          />
        </a-form-item>

        <a-form-item
          :label="$t('login.confirm')"
          name="confirm"
          :rules="[{ required: true, message: t(`login.confirmin`) }]"
        >
          <a-input-password
            v-model:value="formState.confirm"
            autocomplete="off"
            :placeholder="$t('login.confirmin')"
          />
        </a-form-item>
      </a-form>
      <template #footer>
        <a-button @click="noCode" v-show="noCodeShow">{{ $t("login.noCode") }}</a-button>

        <a-button
          key="submit"
          type="primary"
          :loading="modLoading"
          @click="handleOk"
          :disabled="modDisabled"
          >{{ $t("login.submit") }}</a-button
        >
      </template>
    </a-modal>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { useRouter } from "vue-router";
import axios from "axios";
import { message } from "ant-design-vue";
import { useI18n } from "vue-i18n";
import { Modal } from "ant-design-vue";

const { t } = useI18n();

const router = useRouter();

const account = ref();
const password = ref();

const loginLoading = ref(false);

const noCodeShow = ref(false);

const open = ref(false);
const formState = ref({
  email: undefined,
  code: undefined,
  password: undefined,
  confirm: undefined,
});
const modDisabled = computed(() => {
  return !(formState.value.email && formState.value.code);
});
const modLoading = ref(false);

const codeDisabled = ref(false);
const codeLoading = ref(false);
const codeinfo = ref(t("register.getCode"));
const count = ref(60);
const VCode = ref(null);
const VEmail = ref("");

let intervalId; // 添加此变量，用于存储定时器的ID
const startCountdown = () => {
  intervalId = setInterval(() => {
    if (count.value > 0) {
      codeinfo.value = count.value + "s" + t("register.wait");
      count.value--;
    } else {
      clearInterval(intervalId);
      codeinfo.value = t("register.getCode");
      codeDisabled.value = false;
      noCodeShow.value = true;
    }
  }, 1000);
};

function handleOk() {
  if (VEmail.value == formState.value.email) {
    if (formState.value.code == VCode.value) {
      modLoading.value = true;
      axios
        .post("api/User/PasswordReset", {
          Account: formState.value.email,
          Password: formState.value.password,
          ConfirmPassword: formState.value.confirm,
        })
        .then(function (response) {
          modLoading.value = false;
          if (response.data.code != 200) {
            message.error(response.data.info);
          } else {
            message.success(t("login.saveSuccess"));
            open.value = false;
          }
        })
        .catch(function (error) {});
    } else {
      message.error(t("register.codeErr"));
    }
  } else {
    message.error(t("login.again"));
  }
}

function getCode() {
  if (formState.value.email) {
    count.value = 60;
    codeDisabled.value = true;
    startCountdown();
    VEmail.value = JSON.parse(JSON.stringify(formState.value.email));
    if (isMail(VEmail.value)) {
      axios
        .post("api/User/RegisterEmlie", {
          Email: formState.value.email,
        })
        .then(function (response) {
          if (response.data.code != 200) {
            VEmail.value = "";
            message.error(response.data.info);
          } else {
            VCode.value = response.data.ReturnData;
          }
        })
        .catch(function (error) {});
    } else {
      axios
        .post("api/User/RegisterMobile", {
          Mobile: formState.value.email,
        })
        .then(function (response) {
          if (response.data.code != 200) {
            VEmail.value = "";
            message.error(response.data.info);
          } else {
            VCode.value = response.data.ReturnData;
          }
        })
        .catch(function (error) {});
    }
  } else {
    message.error(t("register.emailin") + "!");
  }
}

function isMail(mail) {
  //判断邮箱
  return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(mail);
}

const login = () => {
  if (!account.value) {
    message.error(t("login.accountEmpty"));
    return;
  }
  if (!password.value) {
    message.error(t("login.passwordEmpty"));
    return;
  }
  loginLoading.value = true;
  let params = {
    Password: password.value,
    Email: "",
    Account: account.value,
  };
  if (isMail(account.value)) {
    params = {
      Password: password.value,
      Email: account.value,
      Account: account.value,
    };
  }
  axios
    .post("api/Login/UserLogin", params)
    .then(function (response) {
      if (response.data.code != 200) {
        message.error(response.data.info);
      } else {
        let user = response.data.ReturnData;
        localStorage.setItem("user", JSON.stringify(user));
        localStorage.setItem("userId", user.UserId);
        localStorage.setItem("isVisitor", false);
        // 存储token信息到localStorage中
        localStorage.setItem("token", user.Token);
        router.push("/index/device");
        message.success({
          content: t("login.success"),
          style: {
            marginTop: "50px",
          },
        });
      }
    })
    .catch(function (error) {})
    .finally(() => {
      loginLoading.value = false;
    });
};
const noCode = () => {
  message.info(t("login.noCodein"));
};
const forget = () => {
  open.value = true;
};
const register = () => {
  router.push("/Register");
};
const back = () => {
  router.push("/");
};
</script>

<style scoped>
.login {
  width: 100%;
  height: 100vh;
  color: black;
  position: relative;
  background: #ffffff url("@/assets/img/login.png");
  background-size: cover;
  background-position-x: 90%;
  background-repeat: no-repeat;
  overflow: hidden;
}

.top {
  color: white;
  position: absolute;
  top: 10%;
  /* 垂直居中 */
  right: 50%;
  transform: translate(50%, 10%);
  /* 移动中心点位置 */
  margin: 0px;
}

.loginbg {
  width: 800px;
  height: 350px;
  background-color: rgba(100, 50, 40, 0.6);
  position: absolute;
  top: 50%;
  /* 垂直居中 */
  right: 200px;
  transform: translate(0%, -40%);
  /* 移动中心点位置 */
  border-radius: 10px;
  overflow-y: visible;
  -moz-box-shadow: 5px 5px 30px black;
  -webkit-box-shadow: 5px 5px 30px black;
  box-shadow: 5px 5px 30px black;
}

.loginbox {
  width: 400px;
  height: 400px;
  background-color: rgba(255, 255, 255, 0.8);
  position: absolute;
  top: 50%;
  /* 垂直居中 */
  right: 50px;
  transform: translate(0%, -50%);
  /* 移动中心点位置 */
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

h1,
h2,
h3 {
  text-align: center;
  margin: 50px;
}

h3 {
  font-size: 24px;
}

.inputbox {
  width: 80%;
}

.login_input {
  width: 100%;
  height: 40px;
  border: 1px solid #e5e6e7;
  border-radius: 1px;
  padding: 6px 12px;
  transition: border-color 0.15s ease-in-out 0s, box-shadow 0.15s ease-in-out 0s;
  font-size: 14px;
  line-height: 1.42857143;
  box-sizing: border-box;
  outline: none;
  margin-bottom: 50px;
}

.login_input:focus {
  box-shadow: 0 0 5px rgba(81, 203, 238, 1);
  border: 1px solid rgba(81, 203, 238, 1);
}

.loginbtn {
  width: 80%;
  height: 40px;
  border-radius: 1px;
  background-color: rgb(255, 70, 16);
  cursor: pointer;
  text-align: center;
  color: white;
  font-size: 18px;
}

.loginbtn:hover {
  background-color: rgb(255, 100, 50);
}

.loginleft {
  width: 350px;
  height: 350px;
  padding: 30px;
  color: white;
}

.title {
  margin-bottom: 20px;
  font-weight: bold;
  font-size: 20px;
}

li {
  margin-bottom: 10px;
}

.leftbottom {
  margin-top: 20px;
  font-weight: bold;
}

.register {
  cursor: pointer;
  color: rgba(20, 100, 250, 1);
}

.back {
  float: right;
  cursor: pointer;
  color: rgba(0, 250, 0, 1);
}

.error {
  position: absolute;
  top: 270px;
  text-align: left;
  width: 80%;
  color: red;
}

.forget {
  float: right;
  margin-top: 20px;
  color: #1890ff;
  cursor: pointer;
  align-self: flex-end;
  margin-right: 40px;
}
</style>
